// The showcase pages: the home page, the products and each product's page. They're full width, laid out by the pages
// themselves rather than in the layout's container, and drawn with site.css's showcase tokens (in either color mode).
export function isShowcasePage(pathname: string): boolean {
    return /^\/(products(\/[^/]+)?\/?)?$/.test(pathname);
}
